<script lang="ts">
  import { Button } from "$lib/components/ui/button"
  import { MoveRight } from "lucide-svelte"
  import { getRequirement } from "$lib/components/Widget2/utils"
  import { t, getCurrentLanguage } from "$lib/utils/i18n"

  interface Props {
    action: any
    processAction: (action: any) => void
  }

  let { action, processAction }: Props = $props()

  const language = getCurrentLanguage()
  const entries = getRequirement(action, "Entries") || 0

  function openUrl(action) {
    const url = action.requirements.find((r) => r.name === "Url")?.value
    window.open(url, "_blank")
  }

  let entryPluralized = $derived(
    t("widget_action_entries", {
      count: Number(entries),
    }),
  )
</script>

<div class="bg-white rounded-lg p-4 shadow-lg">
  <div class="mb-4">
    <h4 class="text-sm font-medium mb-2">
      {t("widget_action_worth", { count: entries, entries: entryPluralized })}
    </h4>
  </div>

  <!-- <div style="left: 0; width: 100%; height: 450px; position: relative;">
    <iframe
      src="https://embed.music.apple.com/us/album/magical-mystery-tour/1441163490"
      style="top: 0; left: 0; width: 100%; height: 100%; position: absolute; border: 0;"
      allowfullscreen
      allow="encrypted-media; fullscreen; clipboard-write;"
    ></iframe>
  </div> -->

  <Button
    variant="default"
    class="w-full bg-black text-white hover:bg-gray-800 flex items-center justify-center gap-2"
    onclick={() => {
      openUrl(action)
      processAction(action)
    }}
  >
    {(action.selectedAction || action.actions)?.translations?.[language]?.name}
    <MoveRight />
  </Button>
</div>
